var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content mb-4",attrs:{"id":"app"}},[_c('app-header'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('b-card-group',{attrs:{"deck":""}},[_c('HelpMenu'),_c('FAQSection'),_c('MainBalance')],1)],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }